import DeviceGroup from "./DeviceGroup.js";
import DeviceGroupId from "./DeviceGroupId.js";
import DeviceType from "./DeviceType.js";
import FirmwareIsUpgrading from "./FirmwareIsUpgrading.js";
import FirmwareUpgradeDuration from "./FirmwareUpgradeDuration.js";
import FirmwareUpgradeErrors from "./FirmwareUpgradeErrors.js";
import FirmwareUpgradeStartedAt from "./FirmwareUpgradeStartedAt.js";
import ForceFirmwareRetry from "./ForceFirmwareRetry.js";
import IntermediaryFirmwareComponents from "./IntermediaryFirmwareComponents.js";
import IsActive from "./IsActive.js";
import Metadata from "./Metadata.js";
import ReportedFirmwareApplication from "./ReportedFirmwareApplication.js";
import ReportedFirmwareApplicationId from "./ReportedFirmwareApplicationId.js";
import ReportedFirmwareComponents from "./ReportedFirmwareComponents.js";
import DeviceTypeId from "./DeviceTypeId.js";
import Id from "./Id.js";
import ImagineGroup from "./ImagineGroup.js";
import ImagineGroupId from "./ImagineGroupId.js";
import ImagineGroupName from "./ImagineGroupName.js";
import ProjectId from "./ProjectId.js";
import Name from "./Name.js";
export default {
  install(molten) {
    molten.addPlugin('Attribute', DeviceGroup);
    molten.addPlugin('Attribute', DeviceGroupId);
    molten.addPlugin('Attribute', DeviceType);
    molten.addPlugin('Attribute', DeviceTypeId);
    molten.addPlugin('Attribute', FirmwareIsUpgrading);
    molten.addPlugin('Attribute', FirmwareUpgradeDuration);
    molten.addPlugin('Attribute', FirmwareUpgradeErrors);
    molten.addPlugin('Attribute', FirmwareUpgradeStartedAt);
    molten.addPlugin('Attribute', ForceFirmwareRetry);
    molten.addPlugin('Attribute', Id);
    molten.addPlugin('Attribute', ImagineGroup);
    molten.addPlugin('Attribute', ImagineGroupId);
    molten.addPlugin('Attribute', ImagineGroupName);
    molten.addPlugin('Attribute', IntermediaryFirmwareComponents);
    molten.addPlugin('Attribute', IsActive);
    molten.addPlugin('Attribute', Metadata);
    molten.addPlugin('Attribute', ProjectId);
    molten.addPlugin('Attribute', ReportedFirmwareApplication);
    molten.addPlugin('Attribute', ReportedFirmwareApplicationId);
    molten.addPlugin('Attribute', ReportedFirmwareComponents);
    molten.addPlugin('Attribute', Name);
  }
};